import React, { useContext, useMemo, useState } from "react";
import i18n from "i18next";
import { HeaderContext } from "../../../store/context/header-context";
import { MediaAuthContext } from "../../../store/context/media-auth-context";
import {
  ANALYTICS_PROPS,
  AVAILABLE_LOGOS,
  // TOOLS_TABS,
} from "./content/index.content";
import { getTrueClasses } from "../../../helpers";
import EN from "../../../locales/en/header-footer.json";
import CN from "../../../locales/cn/header-footer.json";
import DE from "../../../locales/de/header-footer.json";
import ES from "../../../locales/es/header-footer.json";
import FR from "../../../locales/fr/header-footer.json";
import JA from "../../../locales/ja/header-footer.json";
// import WebinarNativeBanner from "../WebinarNativeBanner";
import Container from "../../common/UI/Container";
import TrackedLink from "../../Analytics/TrackedLink";
import Panel from "./Panel";
import MobilePanel from "./MobilePanel";
import "react-slidedown/lib/slidedown.css";
import "./index.scss";
import "./local.scss";

const resources = {
  en: { translation: EN },
  cn: { translation: CN },
  de: { translation: DE },
  es: { translation: ES },
  fr: { translation: FR },
  ja: { translation: JA },
};

const Header = (props) => {
  const {
    bgHeader,
    isAbsoluteHeader,
    isHiddenNavigation,
    isShowLanguageSwitcher,
    isShowWebinarNativeBanner,
    language = "en",
    openPricingModal,
    pricingRef,
  } = props;
  const LANGUAGE = useMemo(
    () => (resources[language] ? language : "en"),
    [language]
  );
  const {
    media: { isDesktop },
  } = useContext(MediaAuthContext);

  const [getState, setState] = useState({
    isOpen: false,
    openMobileDropMenu: "",
    // toolsTab: TOOLS_TABS.SITE,
  });

  if (isHiddenNavigation) {
    return null;
  }

  i18n.init({
    lng: LANGUAGE,
    resources,
  });

  const t = i18n.t;
  const isPricingButton = process.env.DEALS_PRICING === "false";
  const { logoPath, logoSrc } = AVAILABLE_LOGOS[LANGUAGE];

  const updateState = (key, value) => {
    setState((prevState) => {
      return {
        ...prevState,
        [key]: value,
      };
    });
  };

  const openMenu = () => {
    const layout = document.getElementById("layout");
    const html = document.body.parentElement;

    if (!getState.isOpen) {
      layout.classList.add("opened");
      html.classList.add("opened");
    } else {
      layout.classList.remove("opened");
      html.classList.remove("opened");
    }
    updateState("isOpen", !getState.isOpen);
  };
  const handlePricingMenu = () => {
    if (!!pricingRef && !!pricingRef.current) {
      !isDesktop && openMenu();
      setTimeout(function () {
        pricingRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    } else {
      openPricingModal && openPricingModal();
    }
  };

  const headerClasses = getTrueClasses(
    "GCL-H",
    LANGUAGE !== "en" && `GCL-H_${LANGUAGE}`,
    isAbsoluteHeader && "GCL-H_absolute",
    isShowWebinarNativeBanner && "GCL-H_WNB",
    getState.isOpen && "opened"
  );

  return (
    <HeaderContext.Provider
      value={{
        getState,
        handlePricingMenu,
        isDesktop,
        isPricingButton,
        isShowLanguageSwitcher,
        language: LANGUAGE,
        openMenu,
        t,
        updateState,
      }}
    >
      <header className={headerClasses} style={{ backgroundColor: bgHeader }}>
        <Container mode="header">
          <div className="GCL-H-NB">
            <TrackedLink
              path={logoPath}
              {...ANALYTICS_PROPS}
              classes="GCL-H-NB-Logo"
            >
              <img className="GCL-H-NB-Logo__img" src={logoSrc} alt="logo" />
            </TrackedLink>
            <Panel />
            <MobilePanel />
          </div>
        </Container>
      </header>
    </HeaderContext.Provider>
  );
};

export default Header;
